export default [{
    path: '/payment',
    name: 'payment',
    meta: {
        title: '支付详情'
    },
    component: () => import('@/views/payment')
}]